/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/js/aa/requestFlightMiles/directives/clickLink.js
*    TO   --> ./legacy-web/src/main/assets/js/request-flight-miles/directives/click-link.js
**/

var RFM_APP = angular.module("RFM_APP");

RFM_APP.directive("clickLink",function(){
    return {
        restrict : "A",
        link: function(scope,elem) {
            elem.click(function(e) {
                e.preventDefault();
                var $this = $j(this);
                var $href = $this.attr("href");
                var $text = $this.text();
                window.open($href, $text, "width=680,height=430,top=125,left=325,status=yes,toolbar=no,menubar=no,location=no");
            });            
        }
    };
});